import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import FormTextField from '../../legacyForm/FormTextField';
import FormAutocompleteField from '../../legacyForm/FormAutocompleteField';

const required = value => value ? undefined : 'Pole jest wymagane';

class TechnikaItAddress extends React.Component {
  render() {
    const { voterRequiredData, streetsAutocompleteData, change, addressRestrictedToCities, disabled } = this.props;
    const cities = _.uniqBy(streetsAutocompleteData, s => s.cityId)
      .filter(s => !addressRestrictedToCities.length || addressRestrictedToCities.includes(s.cityName))
      .map(s => ({ id: s.cityId, name: s.cityName }));
    return (
      <React.Fragment>
        <div>
          <Field
            name="voter.cityId"
            component={FormAutocompleteField}
            label="Miejscowość"
            placeholder="Miejscowość"
            validate={voterRequiredData.addressOptional ? undefined : required}
            autocompleteData={cities}
            disabled={disabled}
            onChange={(_, value) => {
              change('voter.addressId', null);
              change('voter.address', null);

              if (value) {
                const selectedCity = cities.find(l => l.id === value);
                change('voter.city', selectedCity.name);
              } else {
                change('voter.city', null);
              }
            }}
          />
        </div>
        <div>
          <Field
            name="voter.addressId"
            component={FormAutocompleteField}
            label="Adres"
            placeholder="Adres"
            validate={
              voterRequiredData.addressOptional || (this.props.cityId && !streetsAutocompleteData.filter(s => s.cityId === this.props.cityId).every(s => s.name))
              ? undefined
              : required
            }
            autocompleteData={streetsAutocompleteData.filter(s => s.cityId === this.props.cityId)}
            disabled={disabled}
            onChange={(_, value) => {
              if (value) {
                const selectedStreet = streetsAutocompleteData.find(s => s.id === value);
                change('voter.address', selectedStreet.name);
              } else {
                change('voter.address', null);
              }
            }}
          />
          <Field
            name="voter.number"
            component={FormTextField}
            label="Numer domu"
            validate={voterRequiredData.addressOptional ? undefined : required}
            style={{ marginRight: 10, width: 110 }}
            disabled={disabled}
          />
          <Field
            name="voter.localNumber"
            component={FormTextField}
            label="Numer lokalu"
            style={{ width: 110 }}
            disabled={disabled}
          />
        </div>
      </React.Fragment>);
  }
}

TechnikaItAddress.propTypes = {
  voterRequiredData: PropTypes.object.isRequired,
  streetsAutocompleteData: PropTypes.array.isRequired,
  change: PropTypes.func.isRequired,
  cityId: PropTypes.number,
  addressRestrictedToCities: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
};

export default TechnikaItAddress;



// WEBPACK FOOTER //
// ./src/components/budget/voting/TechnikaItAddress.js